// =============================================================================
// src/features/analytics/analytics-demo-tag.ts - Tag "demonstracao" do Analytics.
//
// Honestidade visual (precedente: rotulo "estimativa" do Explore quando
// ELECTORAL_DATA_REAL=false): quando o Analytics esta LIVE, as superficies que
// continuam mock (sentimento/alcance/SoV/digest de IA — backlog F3.1/F3.2)
// ganham esta tag. No fallback total (static) a tag some e o mock fica
// visualmente identico ao de antes — nao ha o que distinguir.
// =============================================================================

import { analyticsLiveSource } from './analytics-live-store';

// ANALYTICS_DEMO_KPI_LABELS foi REMOVIDO em 2026-07-25: os 4 KPIs do strip
// viraram reais no live (views de video e municipios citados substituiram os
// mocks de alcance/sentimento) — nao ha mais KPI de demonstracao a rotular.

/** Cards da comparacao que seguem mock quando live. */
export const ANALYTICS_DEMO_COMPARISON_METRICS: ReadonlySet<string> = new Set([
  'Alcance', 'Mencoes negativas', 'Mencoes positivas',
]);

/** Tag "demonstracao" — string vazia enquanto a fonte for static. */
export function analyticsDemoTagMarkup(): string {
  if (analyticsLiveSource() !== 'live') return '';
  return '<small class="u-analytics-demo-tag">demonstracao</small>';
}
